// import axios from "axios";
import {generateURL} from './config';
import {uts} from "@/js/functions";
import axiosInstance from '../js/axiosInstance.js';

export function getStaticData(key) {
    if (typeof key == 'undefined') {
      return staticDatas;
    }
    
    return staticDatas[key];
}

let dynamicDataPromise = null;

export async function getDynamicData(key, force = false) {
  if (typeof key === 'undefined') {
    key = false;
  }

  const dynamicData = localStorage.getItem('dynamicData');
  const dynamicDataLastUpdated = localStorage.getItem('dynamicDataLastUpdated');

  const isFresh = dynamicData != null &&
    dynamicDataLastUpdated != 0 &&
    (uts() - dynamicDataLastUpdated) <= 21600 &&
    !force;

  if (isFresh) {
    return JSON.parse(dynamicData);
  }

  if (dynamicDataPromise) {
    return dynamicDataPromise;
  }

  dynamicDataPromise = (async () => {
    const apiURL = generateURL('getDynamicData');
    let data = {};

    const dynamicDataResponse = await axiosInstance.post(apiURL, {}, {
      reloadOnClose: true,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    if (dynamicDataResponse?.error) {
      localStorage.removeItem('dynamicData');
      dynamicDataPromise = null;
      return;
    }

    if (typeof dynamicDataResponse.data.status !== 'undefined') {
      switch (dynamicDataResponse.data.status) {
        case 'success':
          console.info('[dh.matrix] Dynamic datas arrived');
          data = dynamicDataResponse.data.data ?? {};
          break;
        default:
          console.error('[dh.matrix] GET dynamic datas error, wrong status arrived:', dynamicDataResponse.data.status);
          break;
      }
    } else {
      console.error('[dh.matrix] GET dynamic datas error, no status arrived!');
    }

    localStorage.setItem('dynamicData', JSON.stringify(data));
    localStorage.setItem('dynamicDataLastUpdated', uts());

    dynamicDataPromise = null;
    return data;
  })();

  return dynamicDataPromise;
}

export let staticDatas = {
    hu: {
      propertyTypes: {
        4080100000001: {
          name: 'flat',
        },
        4080100000002: {
          name: 'house',
          subTypes: {
            4040100000023: 'familyHouse',
            4040100000024: 'terracedHouse',
            4040100000025: 'semidetachedHouse',
            4040100000026: 'partOfHouse',
            4040100000027: 'villa',
            4040100000028: 'castle',
            4040100000029: 'ranch',
          },
        },
        4080100000003: {
          name: 'plot',
          subTypes: {
            4040100000017: 'residentialPlot',
            4040100000018: 'recreationalPlot',
            4040100000019: 'commercialPlot',
            4040100000020: 'industrialPlot',
            4040100000021: 'developmentAreaPlot',
          },
        },
        4080100000005: {
          name: 'office',
        },
        4080100000006: {
          name: 'officeBuilding',
          subTypes: {
            4040100000034: 'officeSpaceInOfficeBuilding',
            4040100000035: 'familyHouse',
            4040100000036: 'apartment',
            4040100000037: 'other',
          },
        },
        4080100000007: {
          name: 'shop',
          subTypes: {
            4040100000030: 'businessHouse',
            4040100000031: 'withStreetEntrance',
            4040100000032: 'courtyard',
            4040100000033: 'other',
          },
        },
        4080100000008: {
          name: 'hospitaly',
          subTypes: {
            4040100000038: 'hotelClassic',
            4040100000039: 'guesthouse',
            4040100000040: 'restaurant',
            4040100000041: 'inn',
            4040100000042: 'otherCateringFacilities',
            4040100000043: 'otherServiceUnit',
            4040100000060: 'hotel',
          },
        },
        4080100000009: {
          name: 'storage',
          subTypes: {
            4040100000044: 'storageRoom',
            4040100000045: 'warehouse',
            4040100000046: 'logisticsPark',
          },
        },
        4080100000010: {
          name: 'industrial',
          subTypes: {
            4040100000047: 'workshop',
            4040100000048: 'location',
            4040100000049: 'other',
            4040100000061: 'refrigeratingStorage',
          },
        },
        4080100000011: {
          name: 'agriculture',
          subTypes: {
            4040100000050: 'farm',
            4040100000051: 'generalAgriculturalProperty',
            4040100000052: 'fertileLand',
            4040100000053: 'arableLand',
            4040100000054: 'forest',
            4040100000055: 'wineCellarWinery',
          },
        },
        4080100000012: {
          name: 'institution',
          subTypes: {
            4040100000056: 'medical',
            4040100000057: 'education',
            4040100000058: 'cultural',
            4040100000059: 'office',
          },
        },
        4080100000013: {
          name: 'general',
          subTypes: {
            2260100000749: 'airport',
            2260100000751: 'barracks',
            2260100000752: 'swimmingPool',
            7520000000959: 'BuiltInAttic',
          },
        },
        4080100000015: {
          name: 'parkingPlace',
          subTypes: {
            7520000000902: 'indoorGarage',
            7520000000903: 'detachedGarage',
            7520000000904: 'ownParkingLotInYard',
          },
        },
      },
      propertyTypesForSearchType: {
        4080100000001: {
          name: 'flat',
        },
        4080100000002: {
          name: 'house',
        },
        4080100000003: {
          name: 'plot',
        },
        4080100000005: {
          name: 'office',
        },
        4080100000006: {
          name: 'officeBuilding',
        },
        4080100000007: {
          name: 'shop',
        },
        4080100000008: {
          name: 'hospitaly',
        },
        4080100000009: {
          name: 'storage',
        },
        4080100000010: {
          name: 'industrial',
        },
        4080100000011: {
          name: 'agriculture',
        },
        4080100000012: {
          name: 'institution',
        },
        4080100000013: {
          name: 'general',
        },
        4080100000015: {
          name: 'parkingPlace',
        },
      },
      contractTypes: {
        4100100000001: 'forSell',
        4100100000002: 'forRent',
      },
      advertisingOptions: {
        2260100000745: 'onlyDatabase',
        2260100000746: 'databaseAndOwnPortals',
        2260100000747: 'everywhere',
        7520000001020: 'onlyTheAuthorizedOfficeMayAdvertise',
        7520000001021: 'itCanBeAdvertisedWithTheCoordinationOfAnAuthorizedSalesperson',
      },
      conditions: {
        2260100000873: '1uninhabitable',
        2260100000874: '2toBeRenovated',
        2260100000875: '3habitable',
        2260100000876: '4good',
        2260100000877: '5veryGood',
        2260100000203: '6newlyBuilt',
      },
      conditionsOutside: {
        2260100000878: '1uninhabitable',
        2260100000879: '2toBeRenovated',
        2260100000880: '3habitable',
        2260100000881: '4good',
        2260100000882: '5veryGood',
        2260100000198: '6newlyBuilt',
      },
      facings: {
        2260100000608: 'gardenInnerGarden',
        2260100000609: 'street',
        2260100000610: 'courtyard',
        2260100000611: 'panorama',
      },
      lightConditions: {
        2260100000055: 'weak',
        2260100000221: 'middle',
        7520000000855: 'good',
        7520000000856: 'sunny',
      },
      orientations: {
        'N': 'north',
        'NE': 'northEast',
        'E': 'east',
        'SE': 'southEast',
        'S': 'south',
        'SW': 'southWest',
        'W': 'west',
        'NW': 'northWest',
      },
      structureOfTheBuilding: {
        2260100000612: 'brick',
        2260100000613: 'panel',
        2260100000614: 'slidingFormwork',
        2260100000615: 'lightStructure',
        2260100000616: 'ytong',
        2260100000617: 'wood',
        2260100000618: 'bauxiteConcrete',
        2260100000619: 'loam',
        2260100000620: 'beatenMasonry',
        2260100000621: 'mixedMasonry',
        2260100000622: 'other',
      },
      heatingTypes: {
        1: {
          'name': 'gas',
          'items': {
            2260100000629: 'gasCirco',
            2260100000630: 'gasConvector',
            2260100000631: 'gasHera',
            2260100000632: 'gasBoiler',
          },
        },
        2: {
          'name': 'districtHeating',
          'items': {
            2260100000633: 'districtHeating',
            2260100000634: 'districtHeatingWithIndividualMeter',
          },
        },
        3: {
          'name': 'houseCentral',
          'items': {
            2260100000635: 'houseCentral',
            2260100000636: 'houseCentralWithIndividualMeter',
          },
        },
        4: {
          'name': 'renewableEnergy',
          'items': {
            7520000000890: 'geothermal',
            7520000000891: 'heatPump',
            7520000000929: 'solarPanel',
          },
        },
        5: {
          'name': 'electronic',
          'items': {
            2260100000640: 'electronic',
            2260100000641: 'electricHera',
            2260100000748: 'infraPanel',
            7520000000888: 'swedishPanel',
            7520000000889: 'electricCirco',
          },
        },
        6: {
          'name': 'indivudualHeatingType',
          'items': {
            2260100000642: 'floorHeating',
            2260100000643: 'wallHeating',
            2260100000644: 'ceilingCoolingHeating',
            2260100000645: 'fanCoil',
            2260100000646: 'mixedFuelBoiler',
            2260100000647: 'tileStove',
            2260100000648: 'other',
          },
        },
        7: {
          'name': 'none',
          'items': {
            2260100000649: 'none',
          },
        },
      },
      costDetailedHeatingTypes: [
        2260100000633,
        2260100000634,
        2260100000635,
        2260100000636,
      ],
      typeOfListingOptions: {
        4100100000001: 'forSell',
        4100100000002: 'forRent',
      },
      contractTypeOptions: {
        4: 'standard+',
        5: 'standard',
        6: 'premium',
        9: 'duo',
      },
      contractTypeOptionsForRent: {
        5: 'standard',
      },
      stateOfTheProperty: {
        2260100000166: 'newlyBuilt',
        2260100000169: 'used',
      },
      exclusiveContractPeriodOptions: {
        2260100000720: '1month',
        2260100000721: '3month',
        2260100000722: '6month',
        2260100000723: '9month',
        2260100000724: '12month'
      },
      duoContractPeriodOptions: {
        // 9990000001167: '1month',
        9990000001351: '3month',
        9990000001353: '6month',
        9990000001355: '9month',
        9990000001357: '12month'
      },
      clientTypeIdOptions: {
        1: 'privatePerson',
        //2: 'selfEmployed',
        3: 'company'
      },
      clientTitleIdOptions: {
        2260100000737: 'owner',
        2260100000738: 'authorized',
        2260100000739: 'representative'
      },
      clientTitleIdOptionsCompany: {
        2260100000738: 'authorized',
        2260100000739: 'representative'
      },
      clientNationalityIdOptions: {
        4040100000001: 'hungarian',
        4040100000002: 'polish',
        7520000000963: 'afghan',
        7520000000995: 'algerian',
        7520000000931: 'american',
        7520000000933: 'azerbaijani',
        7520000000964: 'belgian',
        7520000000994: 'bulgarian',
        4040100000008: 'british',
        7520000000926: 'cypriot',
        4040100000006: 'czech',
        7520000001108: 'danish',
        7520000000945: 'southKorea',
        7520000000937: 'egyptian',
        7520000000989: 'estonia',
        7520000000946: 'finnish',
        7520000000925: 'french',
        7520000000956: 'greek',
        7520000001094: 'georgian',
        7520000000928: 'netherlands',
        4040100000010: 'croatian',
        7520000000991: 'indian',
        4040100000009: 'irish',
        7520000001105: 'iraqui',
        7520000000943: 'iranian',
        7520000000958: 'israeli',
        //7520000001109: 'israeli',
        7520000001036: 'japanise',
        7520000000988: 'canadian',
        4040100000003: 'chinese',
        7520000000940: 'kosovo',
        7520000001037: 'libian',
        7520000000941: 'lithuanian',
        4040100000005: 'german',
        7520000001070: 'nigerian',
        //7520000001071: 'nigerian',
        7520000000939: 'norwegian',
        7520000000942: 'italian',
        4040100000004: 'russian',
        7520000000930: 'austria',
        7520000001093: 'armenian',
        7520000000957: 'pakistani',
        4040100000013: 'romanian',
        7520000000986: 'spanish',
        7520000000935: 'swiss',
        7520000000938: 'swedish',
        7520000000934: 'serbian',
        7520000000990: 'syria',
        4040100000007: 'slovak',
        4040100000012: 'slovenian',
        7520000000927: 'turkish',
        4040100000011: 'ukrainian',
        7520000001107: 'venezuelan',
        7520000000993: 'vietnamese',
      },
      ownershipOptions: {
        1: '1/1',
        2: '1/2',
        3: '1/3',
        4: '1/4',
        5: '1/5',
        6: '1/6',
        7: '1/7',
        8: '1/8',
        9: '1/9',
        10: '1/10'
      },
      natureOfOwnershipInterestOptions: {
        1: 'owner',
        2: 'beneficiary',
      },
      energyRatings: {
        2260100000650: 'AA++',
        2260100000651: 'AA+',
        2260100000652: 'AA',
        2260100000653: 'BB',
        2260100000654: 'CC',
        2260100000655: 'DD',
        2260100000656: 'EE',
        2260100000657: 'FF',
        2260100000658: 'GG',
        2260100000659: 'HH',
        2260100000660: 'II',
        2260100000661: 'JJ',
      },
      typeOfTheElevators: {
        2260100000623: 'caller',
        2260100000624: 'key',
        2260100000625: 'freightElevator',
        2260100000626: 'noElevator',
        7520000000916: 'patientLift',
      },
      typeOfStaircase: {
        2260100000627: 'circularCorridor',
        2260100000628: 'closed',
      },
      typeOfRooms: {
        8: {
          title: 'rooms',
          items: {
            2260100000537: 'room',
            2260100000538: 'livingRoom',
            2260100000539: 'livingRoomPlusAmericanKitchen',
          }
        },
        5070000000036: {
          title: 'bathrooms',
          items: {
            2260100000547: 'bath',
            2260100000548: 'bathWithWC',
          }
        },
        7520000000034: {
          title: 'balconies',
          items: {
            2260100000543: 'balcony',
            2260100000544: 'lodge',
            2260100000545: 'coveredTeracce',
            2260100000546: 'openedTeracce',
          }
        },
        'other': {
          title: 'other',
          items: {
            2260100000540: 'alcove',
            2260100000541: 'anteRoom',
            2260100000542: 'diningRoom',
            2260100000549: 'wardrobe',
            2260100000550: 'hall',
            2260100000551: 'sleepingCabin',
            2260100000552: 'householdRoom',
            2260100000553: 'chamber',
            2260100000554: 'kitchen',
            2260100000555: 'kitchenPlusDiningRoom',
            2260100000556: 'commuter',
            2260100000557: 'staircase',
            7520000000987: 'garden',
            2260100000558: 'winterGarden',
            2260100000559: 'cellar',
            2260100000560: 'wineCellar',
            2260100000561: 'wc',
            7520000000827: 'foreground',
            7520000000792: 'wellnessRoom',
            7520000000793: 'engineRoom',
            7520000000794: 'storageInProperty',
            7520000000795: 'salesSpace',
            7520000000796: 'customerSpace',
            7520000000797: 'guestSpace',
            7520000000798: 'bar',
            7520000000799: 'showRoom',
            7520000000800: 'wineStorage',
            7520000000801: 'portico',
            7520000000802: 'preparationRoom',
            7520000000803: 'corridor',
            7520000000804: 'cookingRoom',
            7520000000805: 'coldRoom',
            7520000000806: 'archives',
            7520000000807: 'cafe',
            7520000000808: 'clubRoom',
            7520000000809: 'meetingRoom',
            7520000000810: 'massageRoom',
            7520000000811: 'hotKitchen',
            7520000000812: 'sink',
            7520000000813: 'dressingRoom',
            7520000000814: 'cloakroom',
            7520000000815: 'garbageContainer',
            7520000000816: 'staffRoom',
            7520000000817: 'safe',
            7520000000818: 'socialRoom',
            7520000000819: 'lavatory',
            7520000000820: 'waterBlock',
            7520000000821: 'reception',
            7520000000822: 'sauna',
            7520000000823: 'room2',
            7520000000824: 'workshop',
            7520000000825: 'kitchenSpace',
            7520000000826: 'storage',
            7520000000828: 'office',
            7520000000829: 'boilerHouseInProperty',
            7520000000830: 'businessPremises',
            7520000000831: 'summerKitchen',
            2260100000563: 'other',
          }
        }
      },
      typeOfConnectedProperties: {
        7520000000892: 'detachedGarage',
        2260100000685: 'garageParking',
        2260100000686: 'surfaceLinebacker',
        2260100000687: 'parkingPlace',
        2260100000688: 'storage',
        7520000000893: 'privateGarden',
        2260100000689: 'stable',
        2260100000690: 'corral',
        2260100000691: 'outbuilding',
        2260100000692: 'wineCellar',
        2260100000693: 'silo',
        2260100000694: 'lake',
        2260100000695: 'forest',
        2260100000696: 'other',
      },
      typeOfCharges: {
        2260100000697: 'commonCost',
        2260100000698: 'water',
        2260100000699: 'gas',
        2260100000700: 'heating',
        7520000000914: 'heatingInWinter',
        2260100000701: 'electricity',
        2260100000702: 'sewage',
        2260100000703: 'renovationFund',
        2260100000704: 'panelProgram',
        2260100000705: 'warehouseRent',
        2260100000706: 'parkingFee',
        2260100000707: 'marketingFee',
        2260100000708: 'operatingCosts',
        2260100000709: 'other',
        7520000000841: 'tax',
      },
      frequencyOfCharges: {
        2260100000710: 'monthly',
        2260100000711: 'twoMonths',
        2260100000712: 'quarters',
        2260100000713: 'halfYear',
        2260100000714: 'annual',
        2260100000715: 'monthPerM2',
        2260100000716: 'monthPerPiece',
        7520000000917: 'flatFee',
      },
      documentTypes: {
        1: 'standardDocument',
        2: 'premiumDocument',
        3: 'propertySheet',
        4: 'elongationContract',
        5: 'other',
        6: 'standardPlusDocument',
        7: 'priceChange',
        8: 'inactivateDocument',
        9: 'personalDocuments',
        10: 'mapSheet',
        11: 'deedOfFundation',
        12: 'technicalDescription',
        13: 'originalFloorPlan',
        14: 'copyOfSignatureTitle',
        15: 'tradeRegister',
        16: 'relinquishmentOfUsufruct',
        17: 'usageSharing',
        18: 'authorization',
      },
      publicUtilityTypesWater: {
        7520000000787: 'inProperty',
        7520000000786: 'innerPlot',
        2260100000670: 'atThePlotBoundary',
        2260100000671: 'inStreet',
        2260100000672: 'none',
      },
      publicUtilityTypesGas: {
        7520000000789: 'inProperty',
        2260100000673: 'innerPlot',
        2260100000674: 'atThePlotBoundary',
        2260100000675: 'inStreet',
        2260100000676: 'none',
      },
      publicUtilityTypesElectricity: {
        7520000000790: 'inProperty',
        2260100000677: 'innerPlot',
        2260100000678: 'atThePlotBoundary',
        2260100000679: 'inStreet',
        2260100000680: 'none',
      },
      publicUtilityTypesDrain: {
        7520000000788: 'inProperty',
        2260100000681: 'innerPlot',
        2260100000682: 'atThePlotBoundary',
        2260100000683: 'inStreet',
        2260100000684: 'none',
      },
      floors: {
        2260100000564: 'basementLevel',
        2260100000565: '-5',
        2260100000566: '-4',
        2260100000567: '-3',
        2260100000568: '-2',
        2260100000569: '-1',
        2260100000570: 'basement1',
        2260100000571: 'basement2',
        2260100000572: 'semiUnderwear',
        2260100000573: 'groundFloor',
        2260100000574: 'mezzanineFloor',
        2260100000575: 'mezzanine',
        2260100000576: '1',
        2260100000577: '2',
        2260100000578: '3',
        2260100000579: '4',
        2260100000580: '5',
        2260100000581: '6',
        2260100000582: '7',
        2260100000583: '8',
        2260100000584: '9',
        2260100000585: '10',
        2260100000586: '11',
        2260100000587: '12',
        2260100000588: '13',
        2260100000589: '14',
        2260100000590: '15',
        2260100000591: '16',
        2260100000592: '17',
        2260100000593: '18',
        2260100000594: '19',
        2260100000595: '20',
        2260100000596: '21',
        2260100000597: '22',
        2260100000598: '23',
        2260100000599: '24',
        2260100000600: '25',
        2260100000601: '26',
        2260100000602: 'attic',
        2260100000603: 'atticSpace',
      },
      personalDocumentTypes: {
        2210100000004: 'idCard',
        2210100000002: 'passport',
        2210100000003: 'drivingLicence',
      },
      prominentPublicFigures: {
        'no': 'no',
        'yesA': 'yesByAPoint',
        'yesB': 'yesByBPoint',
        'yesC': 'yesByCPoint',
        'yesD': 'yesByDPoint',
        'yesE': 'yesByEPoint',
        'yesF': 'yesByFPoint',
        'yesG': 'yesByGPoint',
        'yesH': 'yesByHPoint',
      },
      loanOptions: {
        '0': 'no',
        '1': 'yes',
        '2': 'dontKnow',
      },
      adminIdentites: [4010100000026, 4010100000034, 4010100000043, 4010100000044, 4010100000046, 4010100000048]
    },
    pl: {
      propertyTypes: {
        4080100000001: {
          name: 'flat',
          subTypes: {
            2260100001756: "apartamentowiec",
            2260100001465: "biurowiec",
            2260100001758: "blizniak",
            2260100001759: "blokMieszkalnoBiurowy",
            2260100001760: "blokMieszkalny",
            2260100001763: "budynekWolnostojacy",
            2260100001766: "domMieszkalnoBiurowy",
            2260100001767: "domMieszkalny",
            2260100001768: "domWielorodzinny",
            2260100001769: "dwurodzinny",
            2260100001770: "falowiec",
            2260100001771: "historycznyStylowy",
            2260100001472: "kamienica",
            2260100001780: "pietroDomu",
            2260100001781: "polBlizniaka",
            2260100001786: "wielorodzinny",
            2260100001787: "wiezowiec",
            2260100001788: "wiezowiecBiurowy"
          }
        },
        4080100000002: {
          name: 'house',
          subTypes: {
            2260100001756: "apartamentowiec",
            2260100001465: "biurowiec",
            2260100001758: "blizniak",
            2260100001759: "blokMieszkalnoBiurowy",
            2260100001760: "blokMieszkalny",
            2260100001762: "budynekBiurowoMagazynowy",
            2260100001763: "budynekWolnostojacy",
            2260100001764: "bungalow",
            2260100001467: "centrumHandlowe",
            2260100001766: "domMieszkalnoBiurowy",
            2260100001767: "domMieszkalny",
            2260100001768: "domWielorodzinny",
            2260100001769: "dwurodzinny",
            2260100001770: "falowiec",
            2260100001771: "historycznyStylowy",
            2260100001472: "kamienica",
            2260100001777: "magazyn",
            2260100001778: "parkLogistyczny",
            2260100001779: "pawilonHandlowy",
            2260100001780: "pietroDomu",
            2260100001781: "polBlizniaka",
            2260100001783: "segmentSkrajny",
            2260100001784: "segmentSrodkowy",
            2260100001785: "uzytkowy",
            2260100001786: "wielorodzinny",
            2260100001787: "wiezowiec",
            2260100001788: "wiezowiecBiurowy",
            2260100001789: "willaBiurowa",
            2260100001790: "wolnostojacy"
          },
        },
        4080100000003: {
          name: 'plot',
          subTypes: {
            2260100001500: "budowlana",
            2260100001504: "lesna",
            2260100001503: "podInwestycje",
            2260100001502: "rekreacyjna",
            2260100001501: "rolna",
            2260100001505: "rolnoBudowlana",
            2260100001506: "siedliskowa"
          },
        }
      },
      propertyTypesForSearchType: {
        4080100000001: {
          name: 'flat',
        },
        4080100000002: {
          name: 'house',
        },
        4080100000003: {
          name: 'plot',
        },
      },
      stateOfPropertyId: {
        2260100000166: {name: "newlyBuilt"},
        2260100001142: {name: "used"},
      },
      contractTypeOptions: {
        5: 'standard',
        6: 'premium',
      },
      contractTypeOptionsForRent: {
        5: 'standard',
        6: 'premium',
      },
      exclusiveContractPeriodOptions: {
        2260100000721: '3month',
        2260100000722: '6month',
        2260100000723: '9month',
        2260100000724: '12month'
      },
      structureOfTheBuilding: {
        2260100001738: 'cellularConcrete',
        2260100001739: 'brick',
        2260100001740: 'preWarBrick',
        2260100001741: 'wooden',
        2260100001742: 'aeratedConcrete',
        2260100001743: 'expandedClay',
        2260100001744: 'mixed',
        2260100001745: 'prefabricated',
        2260100001746: 'hollowBrick',
        2260100001747: 'ceramicHollowBrick',
        2260100001748: 'slagHollowBrick',
        2260100001749: 'sandwichPanel',
        2260100001750: 'HFrame',
        2260100001751: 'silicate',
        2260100001752: 'skeleton',
        2260100001753: 'thermomur',
        2260100001754: 'largePanel',
        2260100001755: 'ytong',
      },
      contractTypes: {
        4100100000001: 'forSell',
        4100100000002: 'forRent',
      },
      advertisingOptions: {
        2260100000745: 'onlyDatabase',
        2260100000746: 'databaseAndOwnPortals',
        2260100000747: 'everywhere',
        2260100000884: 'onlyTheAuthorizedOfficeMayAdvertise',
        7520000001020: 'onlyTheSellerSideOfficeCanAdvertise',
        9990000001091: 'onlyAgent'
      },
      conditions: {
        2260100000873: '1uninhabitable',
        2260100000875: '4habitable',
        2260100000923: '8highStandard',
        2260100000924: '5toBeIntroduced',
        2260100000925: '2forRenovation',
        2260100000926: '7developers',
        2260100000927: '6higherStandard',
        2260100000928: '3forRefresh',
        2260100001826: '9newIntact'
      },
      conditionsOutside: {
        2260100001815: '7developers',
        2260100001816: '3forRefresh',
        2260100001817: '2forRenovation',
        2260100001818: '4habitable',
        2260100001820: '6higherStandard',
        2260100001823: '8highStandard',
        2260100001824: '1uninhabitable',
        2260100001825: '5toBeIntroduced',
        2260100001828: '9newIntact'
      },
      facings: {
        2260100000887: 'park',
        2260100000888: 'forest',
        2260100000889: 'lake',
        2260100000890: 'river',
        2260100000891: 'sea',
        2260100000892: 'otherBuildings',
        2260100000893: 'cityPanorama',
        2260100000894: 'yard',
        2260100000895: 'field',
        2260100000896: 'mountains',
        2260100000897: 'streets',
        2260100000898: 'garden',
        2260100000900: 'oldTrees',
        2260100000902: 'youngForest',
        2260100000903: 'court',
        2260100000904: 'singleTrees'
      },
      lightConditions: {
        2260100001811: 'verySunny',
        2260100001812: 'sunny',
        2260100001813: 'littleSunny',
        2260100001814: 'dark'
      },
      // PL: only the 4 cardinal directions, combinable via multi-select (value is stored as "N,E,...")
      orientations: {
        'N': 'north',
        'E': 'east',
        'S': 'south',
        'W': 'west',
      },
      heatingTypes: {
        1: {
          "name": "gas",
          "items": {
            2260100000939: "urban",
            2260100000940: "cityGas",
            2260100000941: "lpg"
          }
        },
        2: {
          "name": "electric",
          "items": {
            2260100000942: "electric"
          }
        },
        3: {
          "name": "coalAndCoke",
          "items": {
            2260100000943: "coal",
            2260100000945: "forCoke"
          }
        },
        4: {
          "name": "oilAndBiomass",
          "items": {
            2260100000944: "biomass",
            2260100000946: "oil"
          }
        },
        5: {
          "name": "renewableEnergy",
          "items": {
            2260100000950: "geothermal",
            2260100000951: "heatPump"
          }
        },
        6: {
          "name": "fireplace",
          "items": {
            2260100000949: "fireplace"
          }
        },
        7: {
          "name": "none",
          "items": {
            2260100000947: "none"
          }
        },
        8: {
          "name": "other",
          "items": {
            2260100000648: "another"
          }
        }
      },
      costDetailedHeatingTypes: [
        // 2260100000633,
        // 2260100000634,
        // 2260100000635,
        // 2260100000636,
      ],
      typeOfListingOptions: {
        4100100000001: 'forSell',
        4100100000002: 'forRent',
      },
      stateOfTheProperty: {
        2260100000166: 'newlyBuilt',
        2260100001142: 'used',
      },
      clientTypeIdOptions: {
        1: 'privatePerson',
        //2: 'selfEmployed',
        // 3: 'company'
      },
      realClientTitleIdOptions: {
        2260100001069: "mrs",
        2260100001080: "mr",
        2260100001810: "mrAndMrs"
      },
      clientTitleIdOptions: {
        2260100000737: 'owner',
        // 2260100000738: 'authorized',
        // 2260100000739: 'representative'
      },
      clientTitleIdOptionsCompany: {
        2260100000737: 'owner',
      },
      clientNationalityIdOptions: { // from dynamic list
        4040100000001: 'hungarian',
        4040100000002: 'polish',
        7520000000963: 'afghan',
        7520000000995: 'algerian',
        7520000000931: 'american',
        7520000000933: 'azerbaijani',
        7520000000964: 'belgian',
        7520000000994: 'bulgarian',
        4040100000008: 'british',
        7520000000926: 'cypriot',
        4040100000006: 'czech',
        7520000001108: 'danish',
        7520000000945: 'southKorea',
        7520000000937: 'egyptian',
        7520000000989: 'estonia',
        7520000000946: 'finnish',
        7520000000925: 'french',
        7520000000956: 'greek',
        7520000001094: 'georgian',
        7520000000928: 'netherlands',
        4040100000010: 'croatian',
        7520000000991: 'indian',
        4040100000009: 'irish',
        7520000001105: 'iraqui',
        7520000000943: 'iranian',
        7520000000958: 'israeli',
        //7520000001109: 'israeli',
        7520000001036: 'japanise',
        7520000000988: 'canadian',
        4040100000003: 'chinese',
        7520000000940: 'kosovo',
        7520000001037: 'libian',
        7520000000941: 'lithuanian',
        4040100000005: 'german',
        7520000001070: 'nigerian',
        //7520000001071: 'nigerian',
        7520000000939: 'norwegian',
        7520000000942: 'italian',
        4040100000004: 'russian',
        7520000000930: 'austria',
        7520000001093: 'armenian',
        7520000000957: 'pakistani',
        4040100000013: 'romanian',
        7520000000986: 'spanish',
        7520000000935: 'swiss',
        7520000000938: 'swedish',
        7520000000934: 'serbian',
        7520000000990: 'syria',
        4040100000007: 'slovak',
        4040100000012: 'slovenian',
        7520000000927: 'turkish',
        4040100000011: 'ukrainian',
        7520000001107: 'venezuelan',
        7520000000993: 'vietnamese',
      },
      ownershipOptions: {
        1: '1/1',
        2: '1/2',
        3: '1/3',
        4: '1/4',
        5: '1/5',
        6: '1/6',
        7: '1/7',
        8: '1/8',
        9: '1/9',
        10: '1/10'
      },
      natureOfOwnershipInterestOptions: {
        1: 'owner',
        2: 'beneficiary',
      },
      energyRatings: {
        2260100000651: 'AA+',
        2260100000652: 'AA',
        2260100000653: 'BB',
        2260100000654: 'CC',
        2260100000655: 'DD',
        2260100000656: 'EE',
        2260100000657: 'FF',
        2260100000658: 'GG',
        2260100000659: 'HH',
        2260100000660: 'II',
        2260100000661: 'JJ',
      },
      typeOfTheElevators: {
        2260100000626: 'noElevator',
        2260100001143: 'freightElevator',
      },
      typeOfStaircase: {
        2260100000932: 'highStandard',
        2260100000933: 'normal',
        2260100000934: 'forRenovation',
        2260100000935: 'developers',
        2260100000936: 'forRefresh',
        2260100000938: 'higherStandard',
      },
      typeOfRooms: {
        8: {
          title: 'rooms',
          items: {
            2260100000537: 'room',
            2260100000538: 'livingRoom',
            2260100000539: 'livingRoomPlusAmericanKitchen',
            2260100001551: 'cabinet',
            2260100001582: 'officeRoom',
            2260100001585: 'childrensRoom',
            2260100001586: 'livingRoom',
            2260100001587: 'guestRoom',
            2260100001589: 'interconnectingRoom',
            2260100001590: 'recreationRoom',
            2260100001591: 'tvRoom',
            2260100001592: 'roomWithKitchenette',
            2260100001619: 'livingRoomWithDiningArea',
            2260100001629: 'bedroom'

          }
        },
        5070000000036: {
          title: 'bathrooms',
          items: {
            2260100000548: 'bathWithWC',
            2260100001631: 'wc',
            2260100001637: 'bath',
            2260100001639: 'childrensBath',
            2260100001640: 'mainBath',
            2260100001641: 'mainBathWithShower',
          }
        },
        // 7520000000034: {
        //   title: 'balconies',
        //   items: {
        //   }
        // },
        'other': {
          title: 'other',
          items: {
            2260100000547: 'bath',
            2260100000557: 'staircase',
            2260100000563: 'other',
            2260100001543: 'diningArea',
            2260100001544: 'kitchenette',
            2260100001545: 'mezzanine',
            2260100001546: 'swimmingPool',
            2260100001547: 'parlor',
            2260100001548: 'noDivision',
            2260100001549: 'library',
            2260100001550: 'openSpaceOffice',
            2260100001553: 'wardrobe',
            2260100001554: 'hall',
            2260100001557: 'diningRoom',
            2260100001558: 'secretOffice',
            2260100001559: 'communication',
            2260100001561: 'corridor',
            2260100001562: 'boiler',
            2260100001564: 'kitchen',
            2260100001566: 'openKitchenWithoutWindow',
            2260100001567: 'openKitchenWithWindow',
            2260100001568: 'kitchenInThePassage',
            2260100001569: 'kitchenWithDiningArea',
            2260100001570: 'closedKitchenWithoutWindow',
            2260100001571: 'closedKitchenWithWindow',
            2260100001572: 'warehouse',
            2260100001575: 'showers',
            2260100001576: 'winterGarden',
            2260100001578: 'basementWithoutWindows',
            2260100001579: 'basementWithWindow',
            2260100001580: 'atticWithWindows',
            2260100001593: 'room',
            2260100001595: 'utilityRoom',
            2260100001597: 'socialRoom',
            2260100001599: 'officeSpace',
            2260100001601: 'exhibitionArea',
            2260100001603: 'laundry',
            2260100001604: 'hall',
            2260100001605: 'vestibule',
            2260100001606: 'reception',
            2260100001609: 'ballroom',
            2260100001610: 'historicalRoom',
            2260100001611: 'cinemaHall',
            2260100001612: 'conferenceRoom',
            2260100001613: 'conferenceRoom',
            2260100001615: 'salesRoom',
            2260100001616: 'multifunctionalHall',
            2260100001620: 'sauna',
            2260100001621: 'stairs',
            2260100001622: 'serverRoom',
            2260100001625: 'pantry',
            2260100001626: 'atticWithoutWindows',
            2260100001627: 'atticWithWindows',
            2260100001628: 'dryer',
            2260100001630: 'dressingRoom',
            2260100001634: 'veranda',
            2260100001635: 'vestibule',
            2260100001636: 'socialFacilities',
            2260100001827: 'warehouse',
            7520000000960: 'detachedGarage',
            7520000000961: 'courtStand',
          }
        }
      },
      typeOfConnectedProperties: {
        2260100000685: 'garageParking',
        2260100000687: 'parkingPlace',
        2260100001642: 'bower',
        2260100001643: 'balcony',
        2260100001646: 'swimmingPool',
        2260100001648: 'railwaySiding',
        2260100001649: 'coldRoom',
        2260100001650: 'additionalPlot',
        2260100001651: 'loadingDock',
        2260100001652: 'guestRecreationCottage',
        2260100001653: 'plot',
        2260100001654: 'plotOfLand',
        2260100001655: 'garage',
        2260100001658: 'workshopHall',
        2260100001660: 'cell',
        2260100001662: 'storageRoom',
        2260100001663: 'tennisCourt',
        2260100001665: 'kitchen',
        2260100001666: 'airstrip',
        2260100001667: 'helicopterPlaneHelipad',
        2260100001668: 'loggia',
        2260100001670: 'warehouse',
        2260100001671: 'magazine',
        2260100001674: 'aboveGroundParkingPlace',
        2260100001675: 'undergroundParkingPlace',
        2260100001676: 'parkingSpaceInTheGroundGarage',
        2260100001677: 'parkingSpaceInTheUndergroundGarage',
        2260100001680: 'showers',
        2260100001681: 'fitnessFacilities',
        2260100001682: 'sportsFacilities',
        2260100001684: 'garden',
        2260100001687: 'winterGarden',
        2260100001689: 'garden',
        2260100001690: 'orangery',
        2260100001691: 'smokingRoom',
        2260100001693: 'parking',
        2260100001694: 'parkingForTrucks',
        2260100001695: 'basement',
        2260100001698: 'maneuveringArea',
        2260100001699: 'pavedSquare',
        2260100001700: 'playground',
        2260100001702: 'room',
        2260100001703: 'socialRoom',
        2260100001705: 'bridge',
        2260100001706: 'yachtHarbour',
        2260100001708: 'ramp',
        2260100001710: 'reception',
        2260100001712: 'cinemaHall',
        2260100001713: 'conferenceRoom',
        2260100001714: 'serverRoom',
        2260100001716: 'dumpster',
        2260100001718: 'stables',
        2260100001720: 'pondLake',
        2260100001722: 'gatehouse',
        2260100001724: 'attic',
        2260100001726: 'dressingRoom',
        2260100001727: 'terrace',
        2260100001730: 'roofTerrace',
        2260100001732: 'shareInTheCommonPartOfThePlot',
        2260100001733: 'toilets',
        2260100001734: 'veranda',
        2260100001735: 'shed',
        2260100001736: 'carport',
        2260100001737: 'building',
        7520000000892: 'detachedGarage'
      },
      typeOfCharges: {
        2260100000697: 'commonCost',
        2260100000698: 'water',
        2260100001015: 'administrativeRent',
        2260100001016: 'taxes',
        2260100001018: 'sewerSepticTankDisposal',
        2260100001019: 'garbageCollection',
        2260100001020: 'energy',
        2260100001021: 'heating',
        2260100001022: 'otherCosts',
        2260100001023: 'gas',
        2260100001024: 'rentIncludedInThePrice'
      },
      frequencyOfCharges: {
        2260100000710: 'monthly',
        2260100001370: 'quarterly',
        2260100001371: 'yearly'
      },
      documentTypes: {
        1: 'brokerageAgreementOpen',
        2: 'exclusiveBrokerageAgreement',
        3: 'pepStatement',
        4: 'ownersStatement',
        5: 'other',
        6: 'energyCertificate',
        22: 'keysInTheOffice',
        23: 'comfortContractDocument'
      },
      publicUtilityTypesWater: {
        2260100000672: 'none',
        2260100000995: 'onThePlot',
        2260100000996: 'onTheAccess',
        2260100000998: 'atDistance'
      },
      publicUtilityTypesGas: {
        2260100000676: 'none',
        2260100000999: 'onThePlot',
        2260100001000: 'onTheAccess',
        2260100001002: 'atDistance'
      },
      publicUtilityTypesElectricity: {
        2260100000680: 'none',
        2260100001003: 'onThePlot',
        2260100001004: 'onTheAccess',
        2260100001006: 'atDistance'
      },
      publicUtilityTypesDrain: {
        2260100000684: 'none',
        2260100001007: 'onThePlot',
        2260100001008: 'onTheAccess',
        2260100001010: 'atDistance'
      },
      floors: {
        2260100000558: 'basement',
        2260100000559: 'groundFloor',
        2260100000560: 'mezzanine',
        2260100000561: '1',
        2260100000562: '2',
        2260100000563: '3',
        2260100000564: '4',
        2260100000565: '5',
        2260100000566: '6',
        2260100000567: '7',
        2260100000568: '8',
        2260100000569: '9',
        2260100000570: '10',
        2260100000571: '11',
        2260100000572: '12',
        2260100000573: '13',
        2260100000574: '14',
        2260100000575: '15',
        2260100000576: '16',
        2260100000577: '17',
        2260100000578: '18',
        2260100000579: '19',
        2260100000580: '20',
        2260100000581: '21',
        2260100000582: '22',
        2260100000583: '23',
        2260100000584: '24',
        2260100000585: '25',
        2260100000586: '26',
        2260100000587: '27',
        2260100000588: '28',
        2260100000589: '29',
        2260100000590: '30',
        2260100000591: '31',
        2260100000592: '32',
        2260100000593: '33',
        2260100000594: '34',
        2260100000595: '35',
        2260100000596: '36',
        2260100000597: '37',
        2260100000598: '38',
        2260100000599: '39',
        2260100000600: '40',
        2260100000601: '41',
        2260100000602: '42',
        2260100000603: '43',
        2260100000604: '44',
        2260100000605: '45',
        2260100000606: '46',
        2260100000607: '47',
        2260100000608: '48',
        2260100000609: '49',
        2260100000610: '50',
        2260100000611: '51',
        2260100000612: '52',
        2260100000613: '53',
        2260100000614: '54',
        2260100000615: '55',
        2260100000616: '56',
        2260100000617: '57',
        2260100000618: '58',
        2260100000619: '59',
        2260100000620: '60'
      },
      personalDocumentTypes: {
        2210100000003: 'passport',
        2210100000004: 'idCard'
      },
      prominentPublicFigures: {
        'no': 'no',
        'yesA': 'yesByAPoint',
        'yesB': 'yesByBPoint',
        'yesC': 'yesByCPoint',
        'yesD': 'yesByDPoint',
        'yesE': 'yesByEPoint',
        'yesF': 'yesByFPoint',
        'yesG': 'yesByGPoint',
        'yesH': 'yesByHPoint',
      },
      loanOptions: {
        '0': 'no',
        '1': 'yes',
        '2': 'dontKnow',
      },
      adminIdentites: [4010100000026, 4010100000034, 4010100000043, 4010100000044, 4010100000046, 4010100000048]
    },
    propertyTypes: {
        4080100000001: {
          name: 'flat',
        },
        4080100000002: {
          name: 'house',
          subTypes: {
            4040100000023: 'familyHouse',
            4040100000024: 'terracedHouse',
            4040100000025: 'semidetachedHouse',
            4040100000026: 'partOfHouse',
            4040100000027: 'villa',
            4040100000028: 'castle',
            4040100000029: 'ranch',
          },
        },
        4080100000003: {
          name: 'plot',
          subTypes: {
            4040100000017: 'residentialPlot',
            4040100000018: 'recreationalPlot',
            4040100000019: 'commercialPlot',
            4040100000020: 'industrialPlot',
            4040100000021: 'developmentAreaPlot',
          },
        },
        4080100000005: {
          name: 'office',
        },
        4080100000006: {
          name: 'officeBuilding',
          subTypes: {
            4040100000034: 'officeSpaceInOfficeBuilding',
            4040100000035: 'familyHouse',
            4040100000036: 'apartment',
            4040100000037: 'other',
          },
        },
        4080100000007: {
          name: 'shop',
          subTypes: {
            4040100000030: 'businessHouse',
            4040100000031: 'withStreetEntrance',
            4040100000032: 'courtyard',
            4040100000033: 'other',
          },
        },
        4080100000008: {
          name: 'hospitaly',
          subTypes: {
            4040100000038: 'hotelClassic',
            4040100000039: 'guesthouse',
            4040100000040: 'restaurant',
            4040100000041: 'inn',
            4040100000042: 'otherCateringFacilities',
            4040100000043: 'otherServiceUnit',
            4040100000060: 'hotel',
          },
        },
        4080100000009: {
          name: 'storage',
          subTypes: {
            4040100000044: 'storageRoom',
            4040100000045: 'warehouse',
            4040100000046: 'logisticsPark',
          },
        },
        4080100000010: {
          name: 'industrial',
          subTypes: {
            4040100000047: 'workshop',
            4040100000048: 'location',
            4040100000049: 'other',
            4040100000061: 'refrigeratingStorage',
          },
        },
        4080100000011: {
          name: 'agriculture',
          subTypes: {
            4040100000050: 'farm',
            4040100000051: 'generalAgriculturalProperty',
            4040100000052: 'fertileLand',
            4040100000053: 'arableLand',
            4040100000054: 'forest',
            4040100000055: 'wineCellarWinery',
          },
        },
        4080100000012: {
          name: 'institution',
          subTypes: {
            4040100000056: 'medical',
            4040100000057: 'education',
            4040100000058: 'cultural',
            4040100000059: 'office',
          },
        },
        4080100000013: {
          name: 'general',
          subTypes: {
            2260100000749: 'airport',
            2260100000751: 'barracks',
            2260100000752: 'swimmingPool',
            7520000000959: 'BuiltInAttic',
          },
        },
        4080100000015: {
          name: 'parkingPlace',
          subTypes: {
            7520000000902: 'indoorGarage',
            7520000000903: 'detachedGarage',
            7520000000904: 'ownParkingLotInYard',
          },
        },
    },
    propertyTypesForSearchType: {
        4080100000001: {
          name: 'flat',
        },
        4080100000002: {
          name: 'house',
        },
        4080100000003: {
          name: 'plot',
        },
        4080100000005: {
          name: 'office',
        },
        4080100000006: {
          name: 'officeBuilding',
        },
        4080100000007: {
          name: 'shop',
        },
        4080100000008: {
          name: 'hospitaly',
        },
        4080100000009: {
          name: 'storage',
        },
        4080100000010: {
          name: 'industrial',
        },
        4080100000011: {
          name: 'agriculture',
        },
        4080100000012: {
          name: 'institution',
        },
        4080100000013: {
          name: 'general',
        },
        4080100000015: {
          name: 'parkingPlace',
        },
    },
    contractTypes: {
        4100100000001: 'forSell',
        4100100000002: 'forRent',
    },
    advertisingOptions: {
        2260100000745: 'onlyDatabase',
        2260100000746: 'databaseAndOwnPortals',
        2260100000747: 'everywhere',
        7520000001020: 'onlyTheAuthorizedOfficeMayAdvertise',
        7520000001021: 'itCanBeAdvertisedWithTheCoordinationOfAnAuthorizedSalesperson',
    },
    conditions: {
      2260100000873: '1uninhabitable',
      2260100000874: '2toBeRenovated',
      2260100000875: '3habitable',
      2260100000876: '4good',
      2260100000877: '5veryGood',
      2260100000203: '6newlyBuilt',
    },
    conditionsOutside: {
      2260100000878: '1uninhabitable',
      2260100000879: '2toBeRenovated',
      2260100000880: '3habitable',
      2260100000881: '4good',
      2260100000882: '5veryGood',
      2260100000198: '6newlyBuilt',
    },
    facings: {
      2260100000608: 'gardenInnerGarden',
      2260100000609: 'street',
      2260100000610: 'courtyard',
      2260100000611: 'panorama',
    },
    lightConditions: {
      2260100000055: 'weak',
      2260100000221: 'middle',
      7520000000855: 'good',
      7520000000856: 'sunny',
    },
    orientations: {
      'N': 'north',
      'NE': 'northEast',
      'E': 'east',
      'SE': 'southEast',
      'S': 'south',
      'SW': 'southWest',
      'W': 'west',
      'NW': 'northWest',
    },
    structureOfTheBuilding: {
        2260100000612: 'brick',
        2260100000613: 'panel',
        2260100000614: 'slidingFormwork',
        2260100000615: 'lightStructure',
        2260100000616: 'ytong',
        2260100000617: 'wood',
        2260100000618: 'bauxiteConcrete',
        2260100000619: 'loam',
        2260100000620: 'beatenMasonry',
        2260100000621: 'mixedMasonry',
        2260100000622: 'other',
    },
    heatingTypes: {
      1: {
        'name': 'gas',
        'items': {
          2260100000629: 'gasCirco',
          2260100000630: 'gasConvector',
          2260100000631: 'gasHera',
          2260100000632: 'gasBoiler',
        },
      },
      2: {
        'name': 'districtHeating',
        'items': {
          2260100000633: 'districtHeating',
          2260100000634: 'districtHeatingWithIndividualMeter',
        },
      },
      3: {
        'name': 'houseCentral',
        'items': {
          2260100000635: 'houseCentral',
          2260100000636: 'houseCentralWithIndividualMeter',
        },
      },
      4: {
        'name': 'renewableEnergy',
        'items': {
          7520000000890: 'geothermal',
          7520000000891: 'heatPump',
          7520000000929: 'solarPanel',
        },
      },
      5: {
        'name': 'electronic',
        'items': {
          2260100000640: 'electronic',
          2260100000641: 'electricHera',
          2260100000748: 'infraPanel',
          7520000000888: 'swedishPanel',
          7520000000889: 'electricCirco',
        },
      },
      6: {
        'name': 'indivudualHeatingType',
        'items': {
          2260100000642: 'floorHeating',
          2260100000643: 'wallHeating',
          2260100000644: 'ceilingCoolingHeating',
          2260100000645: 'fanCoil',
          2260100000646: 'mixedFuelBoiler',
          2260100000647: 'tileStove',
          2260100000648: 'other',
        },
      },
      7: {
        'name': 'none',
        'items': {
          2260100000649: 'none',
        },
      },
    },
    costDetailedHeatingTypes: [
      2260100000633,
      2260100000634,
      2260100000635,
      2260100000636,
    ],
    typeOfListingOptions: {
      4100100000001: 'forSell',
      4100100000002: 'forRent',
    },
    contractTypeOptions: {
      4: 'standard+',
      5: 'standard',
      6: 'premium',
    },
    contractTypeOptionsForRent: {
      5: 'standard',
    },
    stateOfTheProperty: {
      2260100000166: 'newlyBuilt',
      2260100000169: 'used',
    },
    exclusiveContractPeriodOptions: {
      2260100000720: '1month',
      2260100000721: '3month',
      2260100000722: '6month',
      2260100000723: '9month',
      2260100000724: '12month'
    },
    clientTypeIdOptions: {
      1: 'privatePerson',
      //2: 'selfEmployed',
      3: 'company'
    },
    clientTitleIdOptions: {
      2260100000737: 'owner',
      2260100000738: 'authorized',
      2260100000739: 'representative'
    },
    clientTitleIdOptionsCompany: {
      2260100000738: 'authorized',
      2260100000739: 'representative'
    },
    clientNationalityIdOptions: {
      4040100000001: 'hungarian',
      4040100000002: 'polish',
      7520000000963: 'afghan',
      7520000000995: 'algerian',
      7520000000931: 'american',
      7520000000933: 'azerbaijani',
      7520000000964: 'belgian',
      7520000000994: 'bulgarian',
      4040100000008: 'british',
      7520000000926: 'cypriot',
      4040100000006: 'czech',
      7520000001108: 'danish',
      7520000000945: 'southKorea',
      7520000000937: 'egyptian',
      7520000000989: 'estonia',
      7520000000946: 'finnish',
      7520000000925: 'french',
      7520000000956: 'greek',
      7520000001094: 'georgian',
      7520000000928: 'netherlands',
      4040100000010: 'croatian',
      7520000000991: 'indian',
      4040100000009: 'irish',
      7520000001105: 'iraqui',
      7520000000943: 'iranian',
      7520000000958: 'israeli',
      //7520000001109: 'israeli',
      7520000001036: 'japanise',
      7520000000988: 'canadian',
      4040100000003: 'chinese',
      7520000000940: 'kosovo',
      7520000001037: 'libian',
      7520000000941: 'lithuanian',
      4040100000005: 'german',
      7520000001070: 'nigerian',
      //7520000001071: 'nigerian',
      7520000000939: 'norwegian',
      7520000000942: 'italian',
      4040100000004: 'russian',
      7520000000930: 'austria',
      7520000001093: 'armenian',
      7520000000957: 'pakistani',
      4040100000013: 'romanian',
      7520000000986: 'spanish',
      7520000000935: 'swiss',
      7520000000938: 'swedish',
      7520000000934: 'serbian',
      7520000000990: 'syria',
      4040100000007: 'slovak',
      4040100000012: 'slovenian',
      7520000000927: 'turkish',
      4040100000011: 'ukrainian',
      7520000001107: 'venezuelan',
      7520000000993: 'vietnamese',
    },
    ownershipOptions: {
      1: '1/1',
      2: '1/2',
      3: '1/3',
      4: '1/4',
      5: '1/5',
      6: '1/6',
      7: '1/7',
      8: '1/8',
      9: '1/9',
      10: '1/10'
    },
    natureOfOwnershipInterestOptions: {
      1: 'owner',
      2: 'beneficiary',
    },
    energyRatings: {
      2260100000650: 'AA++',
      2260100000651: 'AA+',
      2260100000652: 'AA',
      2260100000653: 'BB',
      2260100000654: 'CC',
      2260100000655: 'DD',
      2260100000656: 'EE',
      2260100000657: 'FF',
      2260100000658: 'GG',
      2260100000659: 'HH',
      2260100000660: 'II',
      2260100000661: 'JJ',
    },
    typeOfTheElevators: {
      2260100000623: 'caller',
      2260100000624: 'key',
      2260100000625: 'freightElevator',
      2260100000626: 'noElevator',
      7520000000916: 'patientLift',
    },
    typeOfStaircase: {
      2260100000627: 'circularCorridor',
      2260100000628: 'closed',
    },
    typeOfRooms: {
      8: {
        title: 'rooms',
        items: {
          2260100000537: 'room',
          2260100000538: 'livingRoom',
          2260100000539: 'livingRoomPlusAmericanKitchen',
        }
      },
      5070000000036: {
        title: 'bathrooms',
        items: {
          2260100000547: 'bath',
          2260100000548: 'bathWithWC',
        }
      },
      7520000000034: {
        title: 'balconies',
        items: {
          2260100000543: 'balcony',
          2260100000544: 'lodge',
          2260100000545: 'coveredTeracce',
          2260100000546: 'openedTeracce',
        }
      },
      'other': {
        title: 'other',
        items: {
          2260100000540: 'alcove',
          2260100000541: 'anteRoom',
          2260100000542: 'diningRoom',
          2260100000549: 'wardrobe',
          2260100000550: 'hall',
          2260100000551: 'sleepingCabin',
          2260100000552: 'householdRoom',
          2260100000553: 'chamber',
          2260100000554: 'kitchen',
          2260100000555: 'kitchenPlusDiningRoom',
          2260100000556: 'commuter',
          2260100000557: 'staircase',
          7520000000987: 'garden',
          2260100000558: 'winterGarden',
          2260100000559: 'cellar',
          2260100000560: 'wineCellar',
          2260100000561: 'wc',
          7520000000827: 'foreground',
          7520000000792: 'wellnessRoom',
          7520000000793: 'engineRoom',
          7520000000794: 'storageInProperty',
          7520000000795: 'salesSpace',
          7520000000796: 'customerSpace',
          7520000000797: 'guestSpace',
          7520000000798: 'bar',
          7520000000799: 'showRoom',
          7520000000800: 'wineStorage',
          7520000000801: 'portico',
          7520000000802: 'preparationRoom',
          7520000000803: 'corridor',
          7520000000804: 'cookingRoom',
          7520000000805: 'coldRoom',
          7520000000806: 'archives',
          7520000000807: 'cafe',
          7520000000808: 'clubRoom',
          7520000000809: 'meetingRoom',
          7520000000810: 'massageRoom',
          7520000000811: 'hotKitchen',
          7520000000812: 'sink',
          7520000000813: 'dressingRoom',
          7520000000814: 'cloakroom',
          7520000000815: 'garbageContainer',
          7520000000816: 'staffRoom',
          7520000000817: 'safe',
          7520000000818: 'socialRoom',
          7520000000819: 'lavatory',
          7520000000820: 'waterBlock',
          7520000000821: 'reception',
          7520000000822: 'sauna',
          7520000000823: 'room2',
          7520000000824: 'workshop',
          7520000000825: 'kitchenSpace',
          7520000000826: 'storage',
          7520000000828: 'office',
          7520000000829: 'boilerHouseInProperty',
          7520000000830: 'businessPremises',
          7520000000831: 'summerKitchen',
          2260100000563: 'other',
        }
      }
    },
    typeOfConnectedProperties: {
      7520000000892: 'detachedGarage',
      2260100000685: 'garageParking',
      2260100000686: 'surfaceLinebacker',
      2260100000687: 'parkingPlace',
      2260100000688: 'storage',
      7520000000893: 'privateGarden',
      2260100000689: 'stable',
      2260100000690: 'corral',
      2260100000691: 'outbuilding',
      2260100000692: 'wineCellar',
      2260100000693: 'silo',
      2260100000694: 'lake',
      2260100000695: 'forest',
      2260100000696: 'other',
    },
    typeOfCharges: {
      2260100000697: 'commonCost',
      2260100000698: 'water',
      2260100000699: 'gas',
      2260100000700: 'heating',
      7520000000914: 'heatingInWinter',
      2260100000701: 'electricity',
      2260100000702: 'sewage',
      2260100000703: 'renovationFund',
      2260100000704: 'panelProgram',
      2260100000705: 'warehouseRent',
      2260100000706: 'parkingFee',
      2260100000707: 'marketingFee',
      2260100000708: 'operatingCosts',
      2260100000709: 'other',
      7520000000841: 'tax',
    },
    frequencyOfCharges: {
      2260100000710: 'monthly',
      2260100000711: 'twoMonths',
      2260100000712: 'quarters',
      2260100000713: 'halfYear',
      2260100000714: 'annual',
      2260100000715: 'monthPerM2',
      2260100000716: 'monthPerPiece',
      7520000000917: 'flatFee',
    },
    documentTypes: {
      1: 'standardDocument',
      2: 'premiumDocument',
      3: 'propertySheet',
      4: 'elongationContract',
      5: 'other',
      6: 'standardPlusDocument',
      7: 'priceChange',
      8: 'inactivateDocument',
      9: 'personalDocuments',
      10: 'mapSheet',
      11: 'deedOfFundation',
      12: 'technicalDescription',
      13: 'originalFloorPlan',
      14: 'copyOfSignatureTitle',
      15: 'tradeRegister',
      16: 'relinquishmentOfUsufruct',
      17: 'usageSharing',
      18: 'authorization',
    },
    publicUtilityTypesWater: {
      7520000000787: 'inProperty',
      7520000000786: 'innerPlot',
      2260100000670: 'atThePlotBoundary',
      2260100000671: 'inStreet',
      2260100000672: 'none',
    },
    publicUtilityTypesGas: {
      7520000000789: 'inProperty',
      2260100000673: 'innerPlot',
      2260100000674: 'atThePlotBoundary',
      2260100000675: 'inStreet',
      2260100000676: 'none',
    },
    publicUtilityTypesElectricity: {
      7520000000790: 'inProperty',
      2260100000677: 'innerPlot',
      2260100000678: 'atThePlotBoundary',
      2260100000679: 'inStreet',
      2260100000680: 'none',
    },
    publicUtilityTypesDrain: {
      7520000000788: 'inProperty',
      2260100000681: 'innerPlot',
      2260100000682: 'atThePlotBoundary',
      2260100000683: 'inStreet',
      2260100000684: 'none',
    },
    floors: {
      2260100000564: 'basementLevel',
      2260100000565: '-5',
      2260100000566: '-4',
      2260100000567: '-3',
      2260100000568: '-2',
      2260100000569: '-1',
      2260100000570: 'basement1',
      2260100000571: 'basement2',
      2260100000572: 'semiUnderwear',
      2260100000573: 'groundFloor',
      2260100000574: 'mezzanineFloor',
      2260100000575: 'mezzanine',
      2260100000576: '1',
      2260100000577: '2',
      2260100000578: '3',
      2260100000579: '4',
      2260100000580: '5',
      2260100000581: '6',
      2260100000582: '7',
      2260100000583: '8',
      2260100000584: '9',
      2260100000585: '10',
      2260100000586: '11',
      2260100000587: '12',
      2260100000588: '13',
      2260100000589: '14',
      2260100000590: '15',
      2260100000591: '16',
      2260100000592: '17',
      2260100000593: '18',
      2260100000594: '19',
      2260100000595: '20',
      2260100000596: '21',
      2260100000597: '22',
      2260100000598: '23',
      2260100000599: '24',
      2260100000600: '25',
      2260100000601: '26',
      2260100000602: 'attic',
      2260100000603: 'atticSpace',
    },
    personalDocumentTypes: {
      2210100000004: 'idCard',
      2210100000002: 'passport',
      2210100000003: 'drivingLicence',
    },
    prominentPublicFigures: {
      'no': 'no',
      'yesA': 'yesByAPoint',
      'yesB': 'yesByBPoint',
      'yesC': 'yesByCPoint',
      'yesD': 'yesByDPoint',
      'yesE': 'yesByEPoint',
      'yesF': 'yesByFPoint',
      'yesG': 'yesByGPoint',
      'yesH': 'yesByHPoint',
    },
    loanOptions: {
      '0': 'no',
      '1': 'yes',
      '2': 'dontKnow',
    },
    adminIdentites: [4010100000026, 4010100000034, 4010100000043, 4010100000044, 4010100000046, 4010100000048]
}